<template>
    <div>
        <input-checkbox v-model="value">
            <slot>{{ texts.default_label }}</slot>
        </input-checkbox>
        <div v-if="errorMessage" class="error">
            {{ errorMessage }}
        </div>
    </div>
</template>

<script>
import InputCheckbox from "@/components/inputs/InputCheckbox";

export default {
    components: {
        InputCheckbox
    },
    props: {
        validate: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        texts() {
            return this.$t("field_customer_delivery_terms_accept");
        },
        errorMessage() {
            if (this.validate && !this.value) return this.texts.required;
            return null;
        },
        value: {
            get() {
                return Boolean(
                    this.$store.getters["customer/getDeliveryTermsAccept"]
                );
            },
            set(deliveryTermsAccept) {
                this.$store.commit("customer/updateCustomer", {
                    deliveryTermsAccept
                });
            }
        }
    }
};
</script>

<style scoped lang="scss">
.error {
    color: red;
    font-size: 0.8em;
    margin-top: 1px;
}
</style>
